export const FETCH_CATEGORIES = 'fetchCategories';
export const SELECT_CATEGORY = 'selectCategory';